<template>
  <el-form-item :label="i18nt('designer.setting.displayDirection')">
    <el-radio-group v-model="optionModel.direction">
      <el-radio label="horizontal" value="horizontal">{{ i18nt('designer.setting.horizontalDirection') }}</el-radio>
      <el-radio label="vertical" value="vertical">{{ i18nt('designer.setting.verticalDirection') }}</el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
import { toRefs } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

export default {
  name: 'direction-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    return {
      i18nt,
      ...toRefs(props),
      ...properyMixins,
    };
  },
};
</script>

<style scoped></style>
